import { twMerge } from 'tailwind-merge';
import { memo, useMemo, type FC } from 'react';
import { estimatePixelLength } from 'String';

const PADDING = 22;

export const CornerIcon: FC<{
    color: 'blue' | 'coral';
    text: string;
    className?: string;
}> = memo(({ color, text, className }) => {
    const width = useMemo(
        () =>
            estimatePixelLength(text, {
                fontSize: 14,
                fontFamily: 'Apercu Regular Pro, ApercuPro',
                fontWeight: '500',
                transform: 'uppercase',
            }) + PADDING,
        [text],
    );

    return (
        <svg
            width={width}
            height="34px"
            viewBox={`0 0 ${width} 34`}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={twMerge('absolute -left-2 -top-2.5 z-[2]', className)}
        >
            <defs>
                <path
                    d="M6.4,4.8 L8,6 L8,6 L8,34 L0,28 L8.8817842e-16,8 C6.17636919e-16,5.790861 1.790861,4 4,4 C4.86548085,4 5.70761532,4.28071149 6.4,4.8 Z"
                    id="path-1"
                />
                <filter
                    x="-50.0%"
                    y="5.9%"
                    width="200.0%"
                    height="111.8%"
                    filterUnits="objectBoundingBox"
                    id="filter-2"
                >
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                    <feColorMatrix
                        values="0 0 0 0 0.129411772   0 0 0 0 0.145098045   0 0 0 0 0.160784319  0 0 0 0.0799999982 0"
                        type="matrix"
                        in="shadowBlurOuter1"
                    />
                </filter>
                <path
                    d={`M4,0 L${width - 4},0 C${width - 1.8},0 ${width},1.8 ${width},4 L${width},24 C${width},26.2 ${
                        width - 1.8
                    },28 ${width - 4},28 L0,28 L0,4 C0,1.8 1.8,0 4,0 Z`}
                    id="path-3"
                />
                <filter
                    x="-5.3%"
                    y="-7.1%"
                    width="110.5%"
                    height="128.6%"
                    filterUnits="objectBoundingBox"
                    id="filter-4"
                >
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                    <feColorMatrix
                        values="0 0 0 0 0.433333337   0 0 0 0 0.418888897   0 0 0 0 0.400833338  0 0 0 0.119999997 0"
                        type="matrix"
                        in="shadowBlurOuter1"
                    />
                </filter>
            </defs>
            <g id="NextUpBox" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Rectangle-484" fillRule="nonzero">
                    <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1" />
                    <use fill={color === 'coral' ? '#A52E3B' : '#0C2D67'} xlinkHref="#path-1" />
                </g>
                <g id="Next-lesson-tag" fillRule="nonzero">
                    <g id="Rectangle-376">
                        <use fill="black" fillOpacity="1" filter="url(#filter-4)" xlinkHref="#path-3" />
                        <use fill={color === 'coral' ? '#FF4D63' : '#4D7AFF'} xlinkHref="#path-3" />
                    </g>
                    <text id="Next-Up-Text" fill="#FFFFFF" fontSize="14" fontWeight="500" className="font-apercu">
                        <tspan x={PADDING / 2} y="19" className="uppercase rtl:hidden">
                            {text}
                        </tspan>
                        <tspan x={width - PADDING / 2} y="19" className="uppercase ltr:hidden">
                            {text}
                        </tspan>
                    </text>
                </g>
            </g>
        </svg>
    );
});
